<template>
    <div v-if="show" class="fixed inset-0 z-50 md:hidden">
        <div class="absolute inset-0 bg-black/40" @click="$emit('close')"></div>

        <div class="absolute inset-y-0 left-0 w-72 max-w-[85vw] bg-white text-gray-500 py-4 px-2 space-y-6 overflow-y-auto shadow-xl">
            <div class="flex items-start justify-between px-2">
                <SidebarBrand class="flex-1" />
                <button type="button" class="p-2 text-gray-400 hover:text-gray-600" aria-label="Fechar menu" @click="$emit('close')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

            <div class="border-b border-1 border-gray-200"></div>

            <SidebarNav />
        </div>
    </div>
</template>

<script>
import SidebarBrand from './SidebarBrand.vue';
import SidebarNav from './SidebarNav.vue';

export default {
    name: 'MobileDrawer',
    components: { SidebarBrand, SidebarNav },
    props: {
        show: { type: Boolean, default: false }
    },
    emits: ['close']
}
</script>
